/**
 * Neural Mesh Navigator
 * 3D Synaptic Navigation with Impulse Propagation
 * 
 * Built with Lit, Three.js, GSAP, and Tailwind CSS
 */

import './style.css'
import './components/neural-mesh-navigator.js'

// Custom console styling
const consoleStyles = {
  title: 'color: #00d4ff; font-size: 16px; font-weight: bold; text-shadow: 0 0 10px #00d4ff;',
  subtitle: 'color: #ff6b9d; font-size: 12px; font-style: italic;',
  success: 'color: #00ff88; font-size: 11px;',
  info: 'color: #4a90a4; font-size: 11px;',
  separator: 'color: #2a4a5a; font-size: 10px;'
}

// Initialize with styled console output
document.addEventListener('DOMContentLoaded', () => {
  console.clear()
  
  console.log('%c╔══════════════════════════════════════════╗', consoleStyles.separator)
  console.log('%c   🧠 Neural Mesh Navigator v1.0', consoleStyles.title)
  console.log('%c   Synaptic Navigation System', consoleStyles.subtitle)
  console.log('%c╚══════════════════════════════════════════╝', consoleStyles.separator)
  
  console.log('')
  console.log('%c✓ Neural network initialized', consoleStyles.success)
  console.log('%c✓ Synapse connections established', consoleStyles.success)
  console.log('%c✓ Impulse propagation system online', consoleStyles.success)
  console.log('%c✓ Camera controller ready', consoleStyles.success)
  console.log('%c✓ Search engine indexed', consoleStyles.success)
  console.log('')
  console.log('%c🎮 Controls: Click nodes | Drag to rotate | Scroll to zoom | ⌘K to search', consoleStyles.info)
  console.log('')
})

// Export for external usage
export { NeuralMeshNavigator } from './components/neural-mesh-navigator.js'
